// TODO:
// Надо бы вынести в отдельный класс, по хорошему он должен иметь стэк курсоров, если будут наложения, чтобы он возвращался к предыдущему и отменял
// тот курсор, который выбран
// Условно:

// Сделали курсор drag
// сделали курсор drop
// отменили drop (получился drag);
// отменили drag (вернулся авто);

// Но можно и в обратном режиме:

// Сделали курсор hover;
// сделали курсор drag;
// отменили курсор hover (остался drag);
// отменили курсор drag (получился auto);

export var setDragCursor = function setDragCursor() {
  document.body.style.cursor = 'grab';
};
export var resetDragCursor = function resetDragCursor() {
  document.body.style.cursor = 'auto';
};